var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-container"},[_c('Header'),_vm._v(" "),_c('b-container',{staticClass:"content",attrs:{"fluid":""}},[_c('b-row',{staticClass:"h-100"},[_c('nuxt')],1)],1),_vm._v(" "),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }